import { CSSProperties } from "react";
import { Breakpoint } from "helpers/hooks";

export type CnInput = string | Array<string | boolean | number | undefined>;
export function cn(value: CnInput): string {
  const values = Array.isArray(value) ? value : [value];
  return values.filter(Boolean).join(" ");
}

/* todo: temporary, rework later */
export type BreakpointCSSProperties = Partial<
  Record<Breakpoint, CSSProperties>
>;
export const breakpointsStyleFromArray = (
  property: string,
  values: Array<string | number> | string | number
) => {
  if (!values || !property) return;

  values = Array.isArray(values) ? values : [values];
  const obj: BreakpointCSSProperties = {};

  values.map((value, index) => {
    switch (index) {
      case 0:
        obj[""] = obj["mobile"] = { [property]: value };
        break;
      case 1:
        obj["tablet"] = { [property]: value };
        break;
      case 2:
      default:
        obj["laptop"] = obj["desktop"] = { [property]: value };
        break;
    }
  });

  return obj;
};
